import DisplayShopName from '../common/DisplayShopName'

export const RetailerCard = ({ retailer }) => {
  return (
    <div className="flex min-w-32 flex-col justify-center">
      <img
        src={retailer.shopPicture}
        alt={retailer.shopName}
        loading="lazy"
        className="h-32 w-32 mx-auto rounded-md object-scale-down bg-background-muted flex items-center justify-center"
      />
      <p className="text-foreground font-semibold truncate mt-1">
        <DisplayShopName
          className="justify-center"
          shop={{
            name: retailer.shopName,
            isPremium: retailer.isPremium,
            isVerified: retailer.isApproved,
          }}
          showIconsOnMobile={false}
        />
      </p>
    </div>
  )
}
